module.exports = __webpack_public_path__ + "static/img/1.0743c42.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/eng/1.png
// module id = vR2N
// module chunks = 0